import { CButton, CForm, CFormInput, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from "@coreui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

export default function SpecialMachinInformationModal({ createDocumentWithConfirm, updateDocumentWithConfirm, modalVisible, data, setModalVisible, formData, setFormData, currentTypeDoc, createDocument, updateDocument, userName,
   docDateEnd, setDocDateEnd,
   currentDoc = undefined, setCurrentDoc = () => { } }) {
   // const [docDateEnd, setDocDateEnd] = useState('')
   // console.log('formData', formData)
   console.log('docDateEnd', docDateEnd)

   useEffect(() => {
      if (currentDoc?.dateEnd) {
         setDocDateEnd(currentDoc.dateEnd);
      }
   }, [currentDoc]);
   // console.log('docDateEnd', docDateEnd.slice(0, 10))
   return (
      <CModal
         visible={modalVisible} onClose={() => {
            setModalVisible(false)
            setCurrentDoc(undefined);
            setDocDateEnd('')
         }}>
         <CModalHeader>
            <CModalTitle>Додати документ: {currentTypeDoc?.type}</CModalTitle>
         </CModalHeader>
         <CModalBody>
            <CForm>
               {/* <CFormInput
                  label="Назва"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="mb-3"
               /> */}
               <CFormInput
                  label="Власник"
                  value={userName}
                  // onChange={(e) => setFormData({ ...formData, ownerName: e.target.value })}
                  className="mb-3"
                  disabled
               />
               <CFormInput
                  type="date"
                  label="Термін дії"
                  // value={docDateEnd}
                  // value={docDateEnd ? docDateEnd.slice(0, 10) : ''}
                  value={docDateEnd ? dayjs(docDateEnd).format('YYYY-MM-DD') : ''}
                  onChange={(e) => setDocDateEnd(e.target.value)}
                  className="mb-3"
                  required
               />

               {/* <CFormInput
                  type="text"
                  label="назва файлу документа"
                  className="mb-3"
                  onChange={(e) => {
                     setFormData(prev => ({ ...prev, name: e.target.value }));
                  }}
               /> */}
               <CFormInput
                  type="file"
                  label="Файл документа"
                  className="mb-3"
                  onChange={(e) => {
                     const file = e.target.files[0];
                     setFormData(prev => ({ ...prev, file, name: file.name }));
                  }}
               />


               {/* <CFormInput
                  type="datetime-local"
                  label="Дата зміни"
                  value={formData.dateModified}
                  onChange={(e) => setFormData({ ...formData, dateModified: e.target.value })}
                  className="mb-3"
               /> */}
            </CForm>
         </CModalBody>
         <CModalFooter>
            <CButton color="secondary" onClick={() => setModalVisible(false)}>
               Скасувати
            </CButton>
            <CButton
               color="primary"
               onClick={() => {
                  // handleSubmitNewDoc();
                  if (currentDoc?.id) {
                     updateDocumentWithConfirm()
                  } else {
                     createDocumentWithConfirm()
                  }
                  setCurrentDoc(undefined);
                  setDocDateEnd('');
                  setModalVisible(false);
               }}
            >
               Зберегти
            </CButton>
         </CModalFooter>
      </CModal>

   )
}